function overflow(options = {}) {
  const inset = {top: 0, right: 0, bottom: 0, left: 0, ...options.inset};

  return {
    get overflowContainer() {
      return this.$refs.overflowContainer;
    },

    isOverflowing: {
      top: false,
      bottom: false,
      left: false,
      right: false,
    },

    checkOverflow() {
      const scrollOffsetBottom = this.overflowContainer.scrollHeight - this.overflowContainer.scrollTop - inset.bottom;
      const scrollOffsetRight = this.overflowContainer.scrollWidth - this.overflowContainer.scrollLeft - inset.right;

      this.isOverflowing.top = this.overflowContainer.scrollTop - inset.top > 0;
      this.isOverflowing.bottom = scrollOffsetBottom > this.overflowContainer.clientHeight;
      this.isOverflowing.left = this.overflowContainer.scrollLeft - inset.left > 0;
      this.isOverflowing.right = scrollOffsetRight > this.overflowContainer.clientWidth;
    },

    scrollTo(options) {
      this.overflowContainer.scrollTo(options);
    },
  };
}

export default overflow;
